import { shorthands } from '@tamagui/shorthands'
import { createTamagui } from '@tamagui/core'

import { animations } from './animations'
import { fonts } from './fonts'
import { tokens } from './tokens'
import { themes } from './themes'

const media = {
  xs: { maxWidth: 480 },
  sm: { maxWidth: 640 },
  md: { maxWidth: 768 },
  gtMd: { minWidth: 769 },
  lg: { maxWidth: 1024 },
  gtLg: { minWidth: 1025 },
  xl: { maxWidth: 1280 },
  gtXl: { minWidth: 1281 },
  xxl: { maxWidth: 1536 },
  short: { maxHeight: 820 },
  tall: { minHeight: 821 },
  hoverNone: { hover: 'none' },
  pointerCoarse: { pointer: 'coarse' },
}

const config = createTamagui({
  defaultFont: 'body',
  animations,
  shouldAddPrefersColorThemes: false,
  themeClassNameOnRoot: true,
  shorthands,
  fonts,
  themes,
  tokens,
  media,
  settings: {
    allowedStyleValues: 'somewhat-strict-web',
    autocompleteSpecificTokens: 'except-special',
    styleCompat: 'react-native',
  },
})

type AppConfig = typeof config

declare module 'tamagui' {
  interface TamaguiCustomConfig extends AppConfig {}
}

export default config
